import { motion } from "framer-motion";
import { Gift, Handshake, Megaphone } from "lucide-react";
import { PARTNERSHIP } from "@/data/content";
import { Kicker, Reveal } from "./Reveal";

const ICONS = { oferecemos: Megaphone, solicitamos: Gift, contrapartida: Handshake };

export const Partnership = () => (
  <section id="parcerias" className="felt relative bg-white px-5 py-24 sm:px-8 sm:py-32" data-testid="parcerias-ganhaganha-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Kicker className="text-[var(--ink)]/70">Parceria ganha-ganha</Kicker>
          <h2 className="font-display mt-3 text-5xl font-extrabold leading-[0.95] text-[var(--ink)] sm:text-6xl">
            Parques, hotéis e atrações: <span className="puffy puffy-blue">bora crescer juntos?</span>
          </h2>
        </div>
        <p className="text-base text-[var(--ink)]/75 sm:text-lg lg:col-span-5">
          Queremos nos conectar com marcas para criar ações e vídeos de grande interesse, gerando benefícios reais e visibilidade atemporal, levando nosso público a destinos incríveis.
        </p>
      </Reveal>
      <ol className="mt-14 grid gap-6 md:grid-cols-3">
        {PARTNERSHIP.map((p, i) => {
          const Icon = ICONS[p.key];
          return (
            <Reveal key={p.key} delay={i * 0.12}>
              <motion.li
                whileHover={{ y: -8, rotate: i === 1 ? 1 : -1 }}
                transition={{ type: "spring", stiffness: 240, damping: 18 }}
                data-testid={`partnership-card-${p.key}`}
                className="relative flex h-full flex-col rounded-[2rem] border-2 border-[var(--ink)]/10 bg-[var(--cream)] p-7"
              >
                <span className="font-display absolute right-6 top-4 text-6xl font-extrabold text-[var(--ink)]/10">0{i + 1}</span>
                <span className="grid h-14 w-14 place-items-center rounded-2xl text-white" style={{ background: p.color }}>
                  <Icon className="h-7 w-7" />
                </span>
                <span className="font-mono-label mt-6 text-xs uppercase tracking-[0.2em] text-[var(--ink)]/65">{p.kicker}</span>
                <h3 className="font-display mt-1 text-2xl font-extrabold text-[var(--ink)]">{p.title}</h3>
                <p className="mt-3 text-[var(--ink)]/75">{p.text}</p>
              </motion.li>
            </Reveal>
          );
        })}
      </ol>
    </div>
  </section>
);
